/* eslint-disable react-hooks/exhaustive-deps */
import { forEach, isEmpty, uniqBy } from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { getWorkHistoryCommuteAllList } from "../../../apis/work-history";
import Calendar from "../../../components/Calendar/Calendar";
import Profile from "../../../components/Profile";
import { dateToFormat, dateToViewFormat, diffDays, getDateRangeList, getDay, yesterDay } from "../../../utils/date";
import { getAllAbsenteeList } from "../../../utils/work-schedule-calculator";
import PerfectScrollbar from "react-perfect-scrollbar";
import Modal, { ModalHeader } from "../../../components/Modal";

const AbsenteeCalendar = () => {
  const calendarRef = useRef(null);
  const {
    employees,
    myRoleEmployeesIdx
  } = useSelector(
    (store) => ({
      employees: store.Data.employees,
      myRoleEmployeesIdx: store.Data.myRoleEmployeesIdx,
    }),
    shallowEqual
  );
  const [list, setList] = useState([])
  const [calendarEvent, setCalendarEvent] = useState([])
  const [dateParams, setDateParams] = useState({
    startDate: "",
    endDate: "",
  });
  // 이벤트 디테일
  const [eventDetailOpen, setEventDetailOpen] = useState(false)
  const [eventDataList, setEventDataList] = useState({})

  const submit = () => {
    // 오늘 부재자
    getWorkHistoryCommuteAllList({
      search: {
        employeeIdxs: myRoleEmployeesIdx
      },
      range: {
        startDate: getDay(),
        endDate: getDay(),
      },
    }).then((res) => {
      const commuteList = res.data.data
      const {
        notCommutedList,
        tardyList,
        earlyLeftList,
        vacationAllList,
        vacationHalfList,
        vacationQuarterList,
        otherWorkList,
        absenteeList,
      } = getAllAbsenteeList(commuteList, employees)
      setList([
        ...notCommutedList.map(({ name, title, ...e }) => ({
          user: { ...e, name: `${name.slice(0, 4)}${name.length >= 4 ? '...' : ''}` },
          data: title || '미출근'
        })),
        ...tardyList.map(({ name, title, ...e }) => ({
          user: { ...e, name: `${name.slice(0, 4)}${name.length >= 4 ? '...' : ''}` },
          data: title || '지각'
        })),
        ...earlyLeftList.map(({ name, title, ...e }) => ({
          user: { ...e, name: `${name.slice(0, 4)}${name.length >= 4 ? '...' : ''}` },
          data: title || '조퇴'
        })),
        ...vacationAllList.map(({ name, title, ...e }) => ({
          user: { ...e, name: `${name.slice(0, 4)}${name.length >= 4 ? '...' : ''}` },
          data: title || '휴가'
        })),
        ...vacationHalfList.map(({ name, title, ...e }) => ({
          user: { ...e, name: `${name.slice(0, 4)}${name.length >= 4 ? '...' : ''}` },
          data: title || '반차'
        })),
        ...vacationQuarterList.map(({ name, title, ...e }) => ({
          user: { ...e, name: `${name.slice(0, 4)}${name.length >= 4 ? '...' : ''}` },
          data: title || '반반차'
        })),
        ...otherWorkList.map(({ name, title, ...e }) => ({
          user: { ...e, name: `${name.slice(0, 4)}${name.length >= 4 ? '...' : ''}` },
          data: title || '기타근무'
        })),
        ...absenteeList.map(({ name, title, ...e }) => ({
          user: { ...e, name: `${name.slice(0, 4)}${name.length >= 4 ? '...' : ''}` },
          data: title || '결근'
        })),
      ])
    }).finally(() => {

    })
  }

  useEffect(() => {
    if (!isEmpty(myRoleEmployeesIdx)) submit()


  }, [employees, myRoleEmployeesIdx])

  useEffect(() => {
    if (!isEmpty(dateParams.startDate) && !isEmpty(myRoleEmployeesIdx)) {
      const { startDate, endDate } = dateParams

      const dateRangeList = getDateRangeList(startDate, endDate)
      let absenteeList = []

      forEach(dateRangeList, (date) => {
        absenteeList.push({ date })
      })

      getWorkHistoryCommuteAllList({
        search: {
          employeeIdxs: myRoleEmployeesIdx
        },
        range: {
          startDate,
          endDate,
        },
      }).then((res) => {
        const commuteList = res.data.data

        forEach(dateRangeList, (date, idx) => {
          const absenteeData = getAllAbsenteeList(commuteList, employees, date)
          absenteeList[idx] = { ...absenteeList[idx], ...absenteeData }
        })

        const ev = []

        forEach(absenteeList, (item) => {
          const {
            earlyLeftList,
            notCommutedList,
            tardyList,
            vacationAllList,
            vacationHalfList,
            vacationQuarterList,
            otherWorkList,
            absenteeList,
          } = item

          if (!isEmpty(earlyLeftList)) {
            ev.push({ start: new Date(item.date), title: `조퇴 ${earlyLeftList.length}건/${uniqBy(earlyLeftList, 'idx').length}명`, list: earlyLeftList })
          }
          if (!isEmpty(notCommutedList) && diffDays(item.date, getDay()) === 0) {
            ev.push({ start: new Date(item.date), title: `미출근 ${notCommutedList.length}건/${uniqBy(notCommutedList, 'idx').length}명`, list: notCommutedList })
          }
          if (!isEmpty(tardyList)) {
            ev.push({ start: new Date(item.date), title: `지각 ${tardyList.length}건/${uniqBy(tardyList, 'idx').length}명`, list: tardyList })
          }
          if (!isEmpty(vacationAllList)) {
            ev.push({ start: new Date(item.date), title: `연차 ${vacationAllList.length}건/${uniqBy(vacationAllList, 'idx').length}명`, list: vacationAllList })
          }
          if (!isEmpty(vacationHalfList)) {
            ev.push({ start: new Date(item.date), title: `반차 ${vacationHalfList.length}건/${uniqBy(vacationHalfList, 'idx').length}명`, list: vacationHalfList })
          }
          if (!isEmpty(vacationQuarterList)) {
            ev.push({ start: new Date(item.date), title: `반반차 ${vacationQuarterList.length}건/${uniqBy(vacationQuarterList, 'idx').length}명`, list: vacationQuarterList })
          }
          if (!isEmpty(otherWorkList)) {
            ev.push({ start: new Date(item.date), title: `기타근무 ${otherWorkList.length}건/${uniqBy(otherWorkList, 'idx').length}명`, list: otherWorkList })
          }
          if (!isEmpty(absenteeList)) {
            ev.push({ start: new Date(item.date), title: `결근 ${absenteeList.length}건/${uniqBy(absenteeList, 'idx').length}명`, list: absenteeList })
          }
        })
        setCalendarEvent(ev)
      })
    }
  }, [dateParams, myRoleEmployeesIdx])

  const onMonthChage = (date) => {
    const startDate = dateToFormat(date.view.currentStart);
    const endDate = dateToFormat(yesterDay(date.view.currentEnd));

    setDateParams({
      startDate,
      endDate,
    });
  };

  const handleEventClick = (e) => {
    setEventDetailOpen(true)
    const eventList = {
      title: `${dateToViewFormat(e.event.start)} ${e.event.title}`,
      employees: [...e.event.extendedProps.list]
    }
    setEventDataList(eventList)
  }

  const close = () => {
    setEventDetailOpen(false)
    setEventDataList([])
  }

  return (
    <>
      <div className="department-absentee-calendar">
        <Calendar
          forwardedRef={calendarRef}
          onMonthChage={onMonthChage}
          event={calendarEvent}
          eventClick={handleEventClick}
        />
        <div className="department-absentee-overview">
          <div className="overview-title-wrap">
            <p className="selected-date">{dateToViewFormat()}</p>
            <p className="discription">부재자</p>
          </div>
          <div className="overview-list-wrap">
            <PerfectScrollbar>
              <div className="list-title-wrap">
                <span className="title">사람</span>
                <span className="title">부재사유</span>
              </div>
              <div className="list-wrap">
                {list.map((absentee, index) => (
                  <div className="list clear" key={index}>
                    <Profile data={absentee.user} />
                    <span className="list-text">{absentee.data}</span>
                  </div>
                ))}
              </div>
            </PerfectScrollbar>
          </div>
        </div>
      </div>
      <Modal size="sm" isOpen={eventDetailOpen} close={close}>
        <div className="department-absentee-detail">
          <ModalHeader>{eventDataList.title}</ModalHeader>
          {!isEmpty(eventDataList) &&
            eventDataList.employees.map((employee, idx) => (
              <div className="employee-list" key={idx}>
                <Profile data={employee} key={idx} />
              </div>
            ))}
        </div>
      </Modal>
    </>
  );
};

export default AbsenteeCalendar;
